import { yup } from '@guiker/yup-util'

import { Consent } from '../../../entity'

export type ConsentSchema = Pick<Consent, 'isConsentGiven'>

export const consentSchema = yup.object<ConsentSchema>({
  isConsentGiven: yup.boolean().required().oneOf([true], 'This must be accepted.'),
})
